import { visit } from 'unist-util-visit';
import type { Root } from 'mdast';

/**
 * Remark plugin to handle `-# text` syntax as subscript/small text
 * Converts lines starting with `-# ` to <small> or <sub> tags
 */
export function remarkSubscript() {
  return (tree: Root) => {
    visit(tree, 'paragraph', (node: any) => {
      // Check if paragraph starts with text node
      if (node.children && node.children[0]?.type === 'text') {
        const text = node.children[0].value;

        // Check if line starts with `-# `
        if (text.startsWith('-# ')) {
          // Convert to small/subscript text
          node.children[0].value = text.replace(/^-# /, '');

          // Wrap in HTML (small tag for styling)
          node.children = [
            {
              type: 'html',
              value: '<small class="text-muted-foreground text-[10px]">',
            },
            ...node.children,
            {
              type: 'html',
              value: '</small>',
            },
          ];
        }
      }
    });
  };
}
